/* eslint-disable warp-drive/no-legacy-request-patterns */
// Extends From
import Route from '@ember/routing/route';

// Ember Imports
import { isEmpty } from '@ember/utils';
import { service } from '@ember/service';

// External Imports
import { hash } from '@linc-technologies/linced-common/utils/promise';
import moment from 'moment';

// Internal Imports
import PersonType from '@linc-technologies/linced-common/enums/person-type';
import PostStatus from '@linc-technologies/linced-common/enums/post-status';

export default class IndexRoute extends Route {
  queryParams = {
    authorIds: {
      refreshModel: true,
    },
    autoFilter: {
      refreshModel: true,
    },
    endTime: {
      refreshModel: true,
    },
    groupIds: {
      refreshModel: true,
    },
    offset: {
      refreshModel: true,
    },
    personIds: {
      refreshModel: true,
    },
    searchQuery: {
      refreshModel: true,
    },
    startTime: {
      refreshModel: true,
    },
    status: {
      refreshModel: true,
    },
  };

  // Services
  @service
  dates;

  @service
  store;

  model(params) {
    let authorIds = '';
    if (!isEmpty(params.authorIds)) {
      authorIds = JSON.stringify(params.authorIds);
    }
    let statuses = [];
    if (params.status !== 0) {
      if (params.status === PostStatus.DRAFT) {
        statuses = JSON.stringify([PostStatus.DRAFT, PostStatus.UNPUBLISHED]);
      } else {
        statuses = JSON.stringify([PostStatus.PUBLISHED]);
      }
    }
    let groupIds = '';
    if (!isEmpty(params.groupIds)) {
      groupIds = JSON.stringify(params.groupIds);
    }
    let offset = 0;
    if (!isEmpty(params.offset)) {
      let temp = Number(params.offset);
      if (!Number.isNaN(temp) && temp > 0) {
        offset = temp;
      }
    }
    let searchQuery = '';
    if (!isEmpty(params.searchQuery)) {
      searchQuery = params.searchQuery;
    }
    let startTime = 0;
    if (!isEmpty(params.startTime)) {
      startTime = moment(params.startTime).startOf('day').unix();
    }
    let endTime = 0;
    if (!isEmpty(params.endTime)) {
      endTime = moment(params.endTime).endOf('day').unix();
    }
    if (!isEmpty(params.autoFilter)) {
      switch (params.autoFilter) {
        case 'day':
          startTime = moment().startOf('day').unix();
          endTime = moment().endOf('day').unix();
          break;
        case 'week':
          startTime = moment().startOf('week').unix();
          endTime = moment().endOf('week').unix();
          break;
        case '7-days':
          startTime = moment().subtract(7, 'days').startOf('day').unix();
          endTime = moment().endOf('day').unix();
          break;
        default:
          this.toaster.error('Invalid Auto Filtering Option');
          break;
      }
    }
    let personIds = '';
    if (!isEmpty(params.personIds)) {
      personIds = JSON.stringify(params.personIds);
    }

    return hash({
      textMessages: this.store.query('posts/text', {
        include: 'reactions,comments',
        perPage: 20,
        authorIds,
        endTime,
        groupIds,
        offset,
        personIds,
        searchQuery,
        startTime,
        statuses,
      }),
      authors: this.store.query('person', {
        type: PersonType.STAFF,
      }),
      groups: this.store.query('group', {
        year: this.dates.currentAcademicYear,
      }),
      update: () => this.refresh(),
    });
  }
}
